import React from "react";

import { Box } from "@mui/material";
import type {
  CardConfig,
  ExposureCardConfig,
  ExposureChartType,
  ExposureDimension,
  ExposureMeasure
} from "store/types";

import { RadioRow } from "./RadioRow";
import { SectionLabel } from "./SectionLabel";

interface Props {
  config: ExposureCardConfig;
  onUpdateConfig: (c: CardConfig) => void;
}

export const ExposureSettings: React.FC<Props> = ({ config, onUpdateConfig }) => {
  return (
    <>
      <Box>
        <SectionLabel>Measure</SectionLabel>
        {(
          [
            ["exposure", "Total Exposure"],
            ["adjNav", "Adjusted NAV"],
            ["unfundedCommitment", "Unfunded Commitment"]
          ] as [ExposureMeasure, string][]
        ).map(([v, l]) => (
          <RadioRow
            key={v}
            label={l}
            selected={config.measure === v}
            onChange={() => onUpdateConfig({ ...config, measure: v })}
          />
        ))}
      </Box>
      <Box>
        <SectionLabel>Dimension</SectionLabel>
        {(
          [
            ["assetClass", "Asset Class"],
            ["Geography", "Geography"],
            ["Strategy", "Strategy"],
            ["vintage", "Vintage"]
          ] as [ExposureDimension, string][]
        ).map(([v, l]) => (
          <RadioRow
            key={v}
            label={l}
            selected={config.dimension === v}
            onChange={() => onUpdateConfig({ ...config, dimension: v })}
          />
        ))}
      </Box>
      <Box>
        <SectionLabel>Chart Style</SectionLabel>
        {(
          [
            ["donut", "Donut"],
            ["pie", "Pie"],
            ["bar", "Horizontal Bar"],
            ["column", "Vertical Bar"],
            ["treemap", "Treemap"]
          ] as [ExposureChartType, string][]
        ).map(([v, l]) => (
          <RadioRow
            key={v}
            label={l}
            selected={config.chartType === v}
            onChange={() => onUpdateConfig({ ...config, chartType: v })}
          />
        ))}
      </Box>
    </>
  );
};
